import { useContext, useMemo } from 'react';
import { makeApiClient } from '@clh/api-client';
import { apiMiddleware } from '@clh/util';
import { useAccessToken } from './use-access-token';
import { ApiClientErrorHandlersContext } from './use-api-client-error-handlers/api-client-error-handlers-context';
import { useConfig } from './use-config';
export function useApiClient(accessTokenFromArgs) {
    const config = useConfig();
    const { accessToken: accessTokenFromHook, error, clhSessionId, } = useAccessToken();
    const accessToken = accessTokenFromArgs || accessTokenFromHook;
    const { onForbidden } = useContext(ApiClientErrorHandlersContext);
    if (!config.apiBaseUrl) {
        throw new Error('apiBaseUrl not provided by ConfigProvider');
    }
    const apiClient = useMemo(() => {
        const apiClient = makeApiClient({
            accessToken: accessToken,
            basePath: config.apiBaseUrl,
            fetchApi: window.fetch,
            middleware: [
                new apiMiddleware.UseSessionHeaderMiddleware(clhSessionId, 'GIT_COMMIT' in window ? window.GIT_COMMIT : ''),
            ],
            onForbidden,
        });
        apiClient.isAuthenticated = !!accessToken;
        apiClient.authenticationFailed = !!error;
        return apiClient;
    }, [accessToken, error, onForbidden]);
    return apiClient;
}
